import { partners } from '../../../services/api.admin';
import { fetchTableData, deleteTableData } from '../tables';
import { MODELS } from '../../../constants/admin/settings';
import { fetchModel, submit } from '../forms';
import { stateToApiData, apiDataToState } from '../../../selectors/admin/models/partners';
import { formDataSelector, dependenciesSelector } from '../../../selectors/admin/forms';
import { get, find } from 'lodash';
import { CLEARING_TO_BE_CONFIRMED } from '../../../constants/settings';
import { contextSubjectSelector } from '../../../selectors/admin/context';

export function fetchList(contextId, pagination) {
    return fetchTableData(
        contextId ? () => partners.getOrg(contextId, pagination) : () => partners.get(pagination),
        'partners',
        { pagination }
    );
}

export function fetchPartnerEvents(eventId, pagination, contextId) {
    return fetchTableData(() => partners.getForEvent(eventId, pagination, contextId), 'partners', {
        pagination,
        transformFunction: (resp, _dispatch, getState) => {
            const clearing = formDataSelector(getState(), { model: MODELS.CONTRACT }).templateClearing || {};
            const dependencies = dependenciesSelector(getState());
            const liveClearing = get(
                find(dependencies.liveStates || [], x => x.id === clearing.liveStateId),
                'name'
            );
            const linearClearing = get(
                find(dependencies.linearStates || [], x => x.id === clearing.linearStateId),
                'name'
            );
            return resp.map(p => {
                p.partnerName = p.name;
                p.liveStateName = liveClearing || CLEARING_TO_BE_CONFIRMED;
                p.linearStateName = linearClearing || CLEARING_TO_BE_CONFIRMED;
                p.comment = clearing.comments || '';
                return p;
            });
        }
    });
}

export function deletePartners() {
    return deleteTableData(partners.delete, MODELS.PARTNER);
}

export function create(data, _modelId, inputData) {
    if (inputData.context) {
        data.organizationIds = [inputData.context];
    }
    return submit(() => partners.create(stateToApiData(data, true)), 'Media partner successfully created.');
}

export function update(data, id, _, onSuccess) {
    return (dispatch, getState) => {
        const context = contextSubjectSelector(getState());
        return submit(() => partners.update(id, stateToApiData(data), context), 'Media partner successfully updated.', {
            beforeDone: (_response, _dispatch, _getState, doneFunction) => {
                onSuccess();
                doneFunction();
            }
        })(dispatch, getState);
    };
}

export function fetchMember(id) {
    return (dispatch, getState) => {
        const context = contextSubjectSelector(getState());
        return fetchModel(() => partners.getMember(id, context), MODELS.PARTNER, {
            transform: apiDataToState
        })(dispatch);
    };
}

export function fetchPartnerContacts(subContextId, pagination, contextId) {
    return fetchTableData(
        contextId
            ? () => partners.getOrgUsers(subContextId, contextId, pagination)
            : () => partners.getUsers(subContextId, pagination),
        'users',
        {
            pagination
        }
    );
}



// WEBPACK FOOTER //
// ./src/actions/admin/models/partners.js